<template>
  <fragment>
    <section class="uk-section-default uk-section">
      <div class="uk-container uk-container-large">
        <div class="uk-grid-margin uk-grid" uk-grid>
          <div
            class="uk-grid-item-match uk-flex-middle uk-width-expand@m uk-visible@m"
          >
            <div class="uk-panel uk-width-1-1">
              <div class="uk-text-small">
                <a href="tel:0317800200">+46 31-780 02 00</a><br />
                <a href="mailto:info@karoon.se">info@karoon.se</a>
              </div>
            </div>
          </div>
          <div class="uk-grid-item-match uk-flex-middle uk-width-expand@m">
            <div class="uk-panel uk-width-1-1">
              <div class="uk-margin uk-text-center">
                <div
                  class="uk-child-width-auto uk-grid-small uk-flex-center uk-grid socialMedia"
                  uk-grid
                >
                  <div>
                    <a
                      class="uk-icon"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://facebook.com/karoonrice"
                      ><i class="fab fa-facebook-f"
                    /></a>
                  </div>
                  <div>
                    <a
                      class="uk-icon"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://instagram.com/karoonrice"
                      ><i class="fab fa-instagram"
                    /></a>
                  </div>
                  <div>
                    <a
                      class="uk-icon"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.youtube.com/channel/UCJalskm9MKT3oEcrpOaCfzQ"
                      ><i class="fab fa-youtube"
                    /></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="uk-grid-item-match uk-flex-middle uk-width-expand@m uk-visible@m"
          >
            <div class="uk-panel uk-width-1-1">
              <div class="uk-text-right uk-text-small">
                © 2020 MSK Bussförsäljning AB, Orgnr: 556845-1859.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </fragment>
</template>

<script>
export default {
  name: "Footer",
  mounted() {
    //
  },
  methods: {},
};
</script>
